import React, { FC, Profiler, useCallback, useEffect, useMemo, useRef, useState } from 'react'

import Calendar from '../../components/Calendar'
import HeaderToolbar from '../../components/Calendar/Toolbar'
import CalendarFilters from '../../components/Calendar/Filters'
import { setSelectedSchedulesAction } from '../../store/calendar/slice'
import SelectedPostPopup, { SELECTED_POPUP_PAGE } from '../../components/SelectedPostPopup'

import { useDispatch, useSelector } from '../../store'
//import { setDateAction, setIsSchedulingPostAction } from '../../store/managePost/slice'
import {
  batchSoftDeletePostsThunk,
  softDeletePostThunk,
  getSchedulesThunk
} from '../../store/calendar/thunks'
import {
  setFiltersAction,
  clearFiltersAction,
  setLabelFiltersAction,
  toggleIsAddingPostAction,
  openSchedulePostModal,
  closeSchedulePostModal,
  setHeaderView
  // toggleIsOpenMultiPostSchedulesUpdateAction
} from '../../store/application/slice'
import { updateScheduleThunk } from '../../store/managePost/thunks'
import { RefsHandler } from '../../components/Calendar/helpers'

import './Calendar.scss'
import MainHeader from '../../components/Calendar/Header'
import ModalSendToApproval from '../../components/PostCreation/SendToApproveModal'
import ModalDuplicatePost from '../../components/Calendar/ModalDuplicatePost'
import { TPost } from '../../store/managePost/types'
import {
  setPostsForApprovalAction,
  toggleIsOpenAprrovalModalAction
} from '../../store/modal/approvalPost/slice'
import { TPostForApproval } from '../../store/managePost/newTypes'
import { setDateAction } from '../../store/managePost/slice'
import { defineAvailablePostsActions } from '../../models/postStatuses'
import {
  HEADER_VIEW,
  SCHEDULE_ACTION_TYPES,
  TModalOptions,
  TypeActionToModal
} from '../../store/application/types'
import ConfirmPopup from '../../components/UI/ConfirmPopup'
import { isFulfilled } from '@reduxjs/toolkit'
import { TOAST_MESSAGE } from '../../components/UI/ToastNotification/ToastNotification'
import { useToasts } from 'react-toast-notifications'
import Preloader, { PRELOADER_TYPE } from '../../components/Preloader'
import { resetPostsForApprovavl } from '../../store/project/slice'
import { TDuplicatePost } from '../../store/modal/duplicatePost/types';
import { setPostsForDuplicate } from '../../store/modal/duplicatePost/slice'

interface AppProps { }

const App: FC<AppProps> = ({ children }) => {
  const dispatch = useDispatch()
  const {
    isUpdatingPostSchedule,
    labels,
    isLoadingSchedule,
    project,
    posts,
    filters,
    isRemovingSchedule,
    selectedPosts,
    scheduleModal
  } = useSelector((state) => ({
    selectedPosts: state.calendar.selectedSchedules,
    scheduleModal: state.app.scheduleModal,
    posts: state.calendar.schedules,
    labels: state.calendar.dayLabels,
    isLoadingSchedule: state.calendar.loaders.schedules.loading,
    project: state.project.currentProject,
    filters: state.app.filters,
    isRemovingSchedule: state.managePost.loaders.post.delete,
    isUpdatingPostSchedule: state.managePost.loaders.schedules.update,
    calendarView: state.app.calendarView
  }))
  const calendarRef = useRef<any>()
  const [calendarApi, setCalendarApi] = useState<any>()
  const setSelectedSchedules = (data: any[]) => {
    dispatch(setSelectedSchedulesAction(data))
  }

  const { addToast } = useToasts()
  const [modalOptions, setModalOptions] = useState<TModalOptions | null>(null)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  // helper to manage not provided by fullcalendar functions
  const calendarDataRefs = useRef(new RefsHandler() as any)
 
  const fetchEvents = useCallback(
    async (range: any) => {
      localStorage.setItem('startEndDates', JSON.stringify([range['start'],range['end']]))
      await dispatch(getSchedulesThunk(range))
    },
    [dispatch]
  )

  useEffect(() => {
    dispatch(setHeaderView(HEADER_VIEW.CALENDAR))
    dispatch(resetPostsForApprovavl())
  }, [])

  const labelFilters = useMemo(
    () =>
      labels.map((label: any) => {
        return {
          labelColor: label.color,
          name: label.text,
          id: label.id,
          checked: true
        }
      }),
    [labels]
  )

  useEffect(() => {
    dispatch(setLabelFiltersAction(labelFilters))
  }, [dispatch, labelFilters])

  const setIsAddingPost = () => {
    dispatch(toggleIsAddingPostAction())
  }
  const toggleUpdateSchedules = () => {
    scheduleModal.isOpen
      ? dispatch(closeSchedulePostModal())
      : dispatch(
        openSchedulePostModal(
          filteredPostsToSchedule.length === 1
            ? SCHEDULE_ACTION_TYPES.SINGLE_SCHEDULE
            : SCHEDULE_ACTION_TYPES.BATCH_SCHEDULES
        )
      )
  }

  const updateSchedules = async (schedules: any[]) => {
    if (!schedules.length) return
    //dispatch(setIsSchedulingPostAction(true))
    const resultUpdate = await Promise.all(
      schedules.map((schedule) => dispatch(updateScheduleThunk({ ...schedule })))
    )
    //dispatch(setIsSchedulingPostAction(false))
  }

  const clearModalOptions = () => {
    setIsModalOpen(false)
    setModalOptions(null)
  }

  const modalProps = useMemo(() => {
    if (modalOptions) {
      const { type } = modalOptions
      switch (type) {
        case TypeActionToModal.DELETE_MULTI_POSTS:
          return {
            onConfirm: async () => {
              const { postsIds } = modalOptions
              clearModalOptions()
              const responseDeletePosts = await dispatch(batchSoftDeletePostsThunk(postsIds))
              if (isFulfilled(responseDeletePosts)) {
                setSelectedSchedules([])
                addToast(TOAST_MESSAGE.POSTS_DELETED, { appearance: 'success' })
              } else {
                addToast(TOAST_MESSAGE.GENERAL_ERROR_MASSEGE, { appearance: 'error' })
              }
            },
            onClose: clearModalOptions
          }
        case TypeActionToModal.DELETE_ONE_POST:
          return {
            onConfirm: async () => {
              const { postId } = modalOptions
              clearModalOptions()
              const responseDeletePost = await dispatch(softDeletePostThunk(postId))
              if (isFulfilled(responseDeletePost)) {
                setSelectedSchedules([])
                addToast(TOAST_MESSAGE.POST_DELETED, { appearance: 'success' })
              } else {
                addToast(TOAST_MESSAGE.GENERAL_ERROR_MASSEGE, { appearance: 'error' })
              }
            },
            onClose: clearModalOptions
          }
      }
    }
  }, [modalOptions])

  const removePosts = () => {
    setModalOptions({
      postId: 0,
      type: TypeActionToModal.DELETE_MULTI_POSTS,
      postsIds: selectedPosts.map((schedule) => schedule.post.id)
    })
    setIsModalOpen(true)
  }

  const filteredPostsToApprove = useMemo(
    () =>
      selectedPosts.filter((schedule) =>
        defineAvailablePostsActions.sendToApprove(schedule.post.status, schedule)
      ),
    [selectedPosts]
  )

  const filteredPostsToSchedule = useMemo(
    () =>
      selectedPosts.filter((schedule) =>
        defineAvailablePostsActions.schedule(schedule.post.status)
      ),
    [selectedPosts]
  )

  const toggleSendToApprovalPosts = async () => {
    const postsForApproval: TPostForApproval[] = filteredPostsToApprove.map(
      ({ date, time, id: scheduleId, post: { post_socials: postSocials, ...post } }) =>
      ({
        ...post,
        postSocials,
        schedule: {
          date,
          time,
          id: scheduleId
        }
      } as TPostForApproval)
    )
    dispatch(setPostsForApprovalAction(postsForApproval))
    dispatch(toggleIsOpenAprrovalModalAction())
  }


const toggleDuplicatePost = () => { 
  if(selectedPosts.length > 0){
    const postForDuplicate: TDuplicatePost = {
    post_id: selectedPosts[0].post.id,
    social_networks: [] 
    }
     dispatch(setPostsForDuplicate(postForDuplicate)) 
  }
}

  const calendarProps = {
    calendarRef,
    setCalendarApi,
    calendarApi,
    labels,
    posts,
    fetchEvents,
    project,
    selectedSchedules: selectedPosts,
    setSelectedSchedules,
    setIsAddingPost,
    setChekedDate: (date: any) => dispatch(setDateAction(date)),
    filters,
    calendarDataRefs,
    updateSchedules
  }

  const filterProps = {
    filters,
    setFilters: (props: any) => {
      calendarDataRefs.current.deleteEventRefs()
      dispatch(setFiltersAction(props))
    },
    clearFilters: () => {
      calendarDataRefs.current.deleteEventRefs()
      dispatch(clearFiltersAction())
    }
  }

  const manageMultiplePostsProps = {
    selectedPostIds: selectedPosts.map((post: TPost) => post.id),
    setSelectedPosts: setSelectedSchedules,
    updateSchedules,
    showDeleteModal: removePosts,
    isRemovingSchedule,
    toggleSendToApprovalPosts,
    toggleUpdateSchedules,
    toggleDuplicatePost,
    isUpdatingPostSchedule,
    page: SELECTED_POPUP_PAGE.CALENDAR,
    qtyToApprove: filteredPostsToApprove.length,
    qtyToSchedule: filteredPostsToSchedule.length
  }

  // const profillerOnRender: React.ProfilerOnRenderCallback = (...props) => {
  //   console.log('profiller', { ...props })
  // }

  return (
    <div className='calendar-page-wrapper'>
      <MainHeader calendarApi={calendarApi} />
      <div className='wrapper-calendar-with-filter'>
        <div className='calendar-wrapper'>
          {isLoadingSchedule && (
            <div className={`main-calendar`}>
              <Preloader type={PRELOADER_TYPE.LOADING_CONTENT} />
            </div>
          )}
          <div className={`main-calendar ${isLoadingSchedule && 'hide'}`}>
            <HeaderToolbar {...{ calendarApi }} />
            {/* <Profiler id='calendarPage' onRender={profillerOnRender}> */}
            <Calendar {...calendarProps} />
            {/* </Profiler> */}
            <SelectedPostPopup {...manageMultiplePostsProps} />
          </div>
        </div>
        <div className='filter-items-wrapper'>
          <CalendarFilters {...filterProps} />
        </div>
      </div>
      <ConfirmPopup {...modalProps} isModalOpen={isModalOpen}>
        Are you sure you want to delete the content?
      </ConfirmPopup>
      <ModalSendToApproval resetSelectedPosts={() => setSelectedSchedules([])} />
      <ModalDuplicatePost />
    </div>
  )
}

export default App
